import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../axios";
import { SignUpReqType } from "@/common/types";

const getRegisterData = async (registerId: string) => {
  return await axiosInstance
    .get(`user/signup/${registerId}`)
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetRegisterData = (registerId: string) => {
  return useQuery<SignUpReqType>({
    queryKey: ["company", "user", "register", registerId],
    queryFn: () => getRegisterData(registerId),
  });
};

export default useGetRegisterData;
